import React from 'react';
import { TabCarouselCardLogoStoryblok } from '../../../../../../types/storyblok';
import { StoryblokImage } from '../../../../../../base/StoryblokImage/StoryblokImage';

export const TabCarouselCardLogo = ({
  image,
}: TabCarouselCardLogoStoryblok) => {
  if (!image) {
    return null;
  }

  return (
    <StoryblokImage
      src={image}
      alt=""
      mode="responsive"
      maxWidth={800}
      className="h-8 w-auto"
    />
  );
};

export default TabCarouselCardLogo;
